// import { Box } from "@mui/material";
// import React, { useEffect } from "react";
// import { useAuth0 } from "@auth0/auth0-react";

// const Logout = () => {
//   const { logout } = useAuth0();

//   useEffect(() => {
//     logout({
//       returnTo: `${window.location.origin}/auth/login`,
//     });
//   }, [logout]);

//   return <Box>Logging out...</Box>;
// };

// export default Logout;

import { Box } from "@mui/material";
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { logout as appLogout } from "../../store/authSlice";
import { useAppDispatch } from "../../store/hooks";

const Logout = () => {
  const { logout } = useAuth0();
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Trigger logout API call with empty payload
    logout({
      logoutParams: { returnTo: `${window.location.origin}/auth/login` },
    });
    dispatch(appLogout());
  }, [logout, dispatch]);

  return <Box>Logging out...</Box>;
};

export default Logout;